import { useEffect } from 'react';

import { selectUser } from 'store';

import { useAppSelector } from 'hooks';
import { socketClose, socketInit } from 'socket';
import SocketFrontDesk from 'socket/socketFrontDesk';
import SocketMessages from 'socket/socketMessages';

export const useSocketLifecycle = () => {
  const { accessToken } = useAppSelector(selectUser);

  useEffect(() => {
    if (!accessToken) return;

    socketInit(SocketMessages, accessToken);
    socketInit(SocketFrontDesk, accessToken);

    return () => {
      socketClose(SocketMessages);
      socketClose(SocketFrontDesk);
    };
  }, [accessToken]);
};
